module.exports = __webpack_public_path__ + "static/media/IMG_8019.2b25bdf9.jpg";